(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (
        scrollTop <= this.headerBounds.top
      ) {
        this.header.classList.remove('scrolled-past-header');

        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.closeAccountMenu();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures ||
        this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) =>
        disclosure.close()
      );
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal ||
        this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }

    closeAccountMenu() {
      const accountMenu =
        this.header.querySelector('.header__account-menu');

      if (accountMenu) {
        accountMenu.removeAttribute('open');
      }
    }
  }

  customElements.define(
    'sticky-header',
    StickyHeader
  );

  document.addEventListener('click', function(event) {
    document
      .querySelectorAll('.header__account-menu[open]')
      .forEach(function(menu) {
        if (!menu.contains(event.target)) {
          menu.removeAttribute('open');
        }
      });
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      document
        .querySelectorAll('.header__account-menu[open]')
        .forEach(function(menu) {
          menu.removeAttribute('open');
        });
    }
  });

  function initCbmStickyDesktopNav() {
    const sectionHeader = document.querySelector('.section-header');
    const nav = sectionHeader?.querySelector('.header__inline-menu');

    if (!sectionHeader || !nav || sectionHeader.dataset.cbmStickyNavReady === 'true') return;

    sectionHeader.dataset.cbmStickyNavReady = 'true';

    const desktopQuery = window.matchMedia('(min-width: 990px)');
    let navStart = 0;
    let ticking = false;

    const deactivate = () => {
      sectionHeader.classList.remove('cbm-nav-sticky-active');
    };

    const measure = () => {
      deactivate();

      if (!desktopQuery.matches) {
        sectionHeader.style.removeProperty('--cbm-sticky-nav-height');
        sectionHeader.style.removeProperty('--cbm-sticky-nav-left');
        sectionHeader.style.removeProperty('--cbm-sticky-nav-width');
        return;
      }

      const rect = nav.getBoundingClientRect();
      navStart = rect.top + window.scrollY;

      sectionHeader.style.setProperty('--cbm-sticky-nav-height', `${rect.height}px`);
      sectionHeader.style.setProperty('--cbm-sticky-nav-left', `${rect.left}px`);
      sectionHeader.style.setProperty('--cbm-sticky-nav-width', `${rect.width}px`);

      update();
    };

    const getAnnouncementHeight = () => {
      const styles = getComputedStyle(document.documentElement);
      const announcementValue = styles.getPropertyValue('--cbm-announcement-height');
      return parseFloat(announcementValue) || 0;
    };

    const update = () => {
      if (!desktopQuery.matches) {
        deactivate();
        return;
      }

      const activationPoint = Math.max(0, navStart - getAnnouncementHeight());
      sectionHeader.classList.toggle('cbm-nav-sticky-active', window.scrollY >= activationPoint);
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    document.addEventListener('cbm:announcement-height-change', measure);
    desktopQuery.addEventListener('change', measure);

    if (document.fonts?.ready) {
      document.fonts.ready.then(measure);
    } else {
      measure();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCbmStickyDesktopNav, { once: true });
  } else {
    initCbmStickyDesktopNav();
  }

  document.addEventListener('shopify:section:load', initCbmStickyDesktopNav);

  } catch(e) { console.error(e); }
})();
})();
